import { DtStandard } from '@ow/ditto-core'

const { config } = DtStandard

export { default as Render } from './render'
export { config }
